import styled from 'styled-components';

export const NoImageContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 200px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: start;
  align-items: center;
  width: 395px;
  max-width: 395px;
  max-height: 710px;
  overflow: hidden;

  #control-image {
    min-height: 150px !important;
  }

  @media (max-width: 1220px) {
    padding-bottom: 8px;
    width: 100%;
    justify-content: center;
    max-width: 715px;
    max-height: 400px;
    flex-direction: column-reverse;
    gap: 16px;

    .bui-compare {
      height: 400px;
    }

    #control-image-wrapper {
      flex-direction: row;
    }

    #control-image {
      height: 195px !important;
      order: 1;
    }

    #image-control {
      order: 2;
      flex-direction: column;
      gap: 4px;
    }

    button {
      order: 3;
    }
  }
`;
